module.exports = "<p>\n  ngraph-graph works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Jeffrey/Documents/web development/ciphersite/src/app/ngraph-graph/ngraph-graph.component.html
// module id = ../../../../../src/app/ngraph-graph/ngraph-graph.component.html
// module chunks = main